const PERMISSION_KEY= "company:bc_business_sector";
const PAGE_URL = {
    B_C_BUSINESS_SECTOR_PAGE: "/admin/company/bc-business-sector"
}

export {PERMISSION_KEY, PAGE_URL}

